// @flow
import React, { Component } from 'react'

import EnterpriseButton from './index'
export default class extends Component {
  static displayName = 'Okta Form'

  render () {
    return (
      <EnterpriseButton {...this.props}>
        <i className='icon icon--okta' />
        Sign In with Okta
      </EnterpriseButton>
    )
  }
}
